import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import TabLayout from './layouts/tab-layout/tab-layout';
import * as Styled from './styles';
import * as SX from './sx';
import type { TabDrawerProps as Props } from './types';

export const TabDrawer = memo(
  ({
    className,
    tabs,
    header,
    subHeader,
    tabContent,
    footer,
    state,
    onClose,
    handleChangeTabs,
    width,
  }: Props) => {
    return (
      <Styled.Wrapper
        titleSx={SX.title}
        state={state}
        onClose={onClose}
        className={classnames('TabDrawer', className)}
        sx={SX.root}
        width={width || 460}
        /* hideBackdrop
        ModalProps={{
          keepMounted: true,
          onClick: ,
          sx: { width: `calc(100vw - ${width || 580}px)` },
        }} */
      >
        <TabLayout
          tabs={tabs}
          header={header}
          subHeader={subHeader}
          footer={footer}
          handleChangeTabs={handleChangeTabs}
        >
          {tabContent}
        </TabLayout>
      </Styled.Wrapper>
    );
  }
);

TabDrawer.displayName = 'TabDrawer';
